import script from "./SpinLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinLoader.vue?vue&type=script&setup=true&lang=js"

import "./SpinLoader.vue?vue&type=style&index=0&id=7211d2e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7211d2e0"]])

export default __exports__